// 车辆类型
const moneyType = [
    {
        label: "10万元",
        value: 100000,
    },
    {
        label: "15万元",
        value: 150000,
    },
    {
        label: "20万元",
        value: 200000,
    },
    {
        label: "30万元",
        value: 300000,
    },
    {
        label: "50万元",
        value: 500000,
    },
    {
        label: "100万元",
        value: 1000000,
    },
    {
        label: "150万元",
        value: 1500000,
    },
    {
        label: "200万元",
        value: 2000000,
    },
    {
        label: "250万元",
        value: 2500000,
    },
    {
        label: "300万元",
        value: 3000000,
    },
    {
        label: "350万元",
        value: 3500000,
    },
    {
        label: "400万元",
        value: 4000000,
    },
    {
        label: "450万元",
        value: 4500000,
    },
    {
        label: "500万元",
        value: 5000000
    },
    {
        label: "550万元",
        value: 5500000
    },
    {
        label: "600万元",
        value: 6000000
    },
    {
        label: "650万元",
        value: 6500000
    },
    {
        label: "700万元",
        value: 7000000
    },
    {
        label: "750万元",
        value: 7500000
    },
    {
        label: "800万元",
        value: 8000000
    }
]
// 检车（废弃，加入到数据字典里）
// const checkInfoOption = [
//     {
//         label: "已超期 需验车",
//         value: "已超期 需验车",
//     },
//     {
//         label: "免验车",
//         value: "免验车",
//     },
//     {
//         label: "需验车 验地标",
//         value: "需验车 验地标",
//     },
//     {
//         label: "验地标",
//         value: "验地标",
//     },
//     {
//         label: "上年无车损 需验车",
//         value: "上年无车损 需验车",
//     },
// ]
// 每座价钱
const seatOption = [
    {
        label: '1万',
        value: '10000',
    },
    {
        label: '2万',
        value: '20000',
    },
    {
        label: '3万',
        value: '30000',
    },
    {
        label: '5万',
        value: '50000',
    },
    {
        label: '10万',
        value: '100000',
    },
    {
        label: '15万',
        value: '150000',
    },
    {
        label: '20万',
        value: '200000',
    },
    {
        label: '25万',
        value: '250000',
    },
    {
        label: '30万',
        value: '300000',
    },
    {
        label: '35万',
        value: '350000',
    },
    {
        label: '40万',
        value: '400000',
    },
    {
        label: '50万',
        value: '500000',
    }
]

// 统筹单状态
const status = [
        {
            label: '未提交',
            value: 0
        },
        {
            label: '待审核',
            value: 1
        },
        {
            label: '核审未通过',
            value: 2
        },
        {
            label: '待交费',
            value: 3
        },
		{
		    label: '已交费',
		    value: 7
		},
        {
            label: '已退统',
            value: 4
        },
        {
            label: '已作废',
            value: 5
        },
        {
            label: '已完成',
            value: 6
        },
]

// 批单状态
const apprStatus = [
    {
        label: '待审核',
        value: 0
    },
    {
        label: '核审未通过',
        value: 1
    },
    {
        label: '待交费',
        value: 2
    },
    {
        label: '已完成',
        value: 4
    },
]

const patModeOption = [
	{
	    label: '拉卡拉',
	    value: '拉卡拉'
	},
	{
	    label: '企业微信',
	    value: '企业微信'
	},
    {
        label: '微信收款码',
        value: '微信收款码'
    },
    {
        label: '公户收款码',
        value: '公户收款码'
    },
    {
        label: '公户',
        value: '公户'
    },
    {
        label: '其他',
        value: '其他'
    },
]
// 附加统筹统筹额
const additionalOption = [
    {
        label: '1万',
        value: '10000',
    },
    {
        label: '2万',
        value: '20000',
    },
    {
        label: '5万',
        value: '50000',
    },
	{
	    label: '10万',
	    value: '100000',
	},
]

export default {
    moneyType,
    // checkInfoOption,
    seatOption,
    status,
    patModeOption,
    apprStatus,
	additionalOption
}